import { AlertCircle } from 'lucide-react'
import FilterPanel from '../components/filters/FilterPanel'
import MetricCards from '../components/dashboard/MetricCards'
import BranchCard from '../components/dashboard/BranchCard'
import RevenueChart from '../components/charts/RevenueChart'
import SalesChart from '../components/charts/SalesChart'
import FuelBreakdownChart from '../components/charts/FuelBreakdownChart'
import { getVisibleBranches } from '../utils/dataHelpers'
import { getTimeSeriesData, getFuelTypeBreakdown } from '../utils/chartHelpers'

export default function AnalyticsPage({
  currentUser,
  filters,
  onDateFilter,
  onFuelTypeFilter,
  onOrgFilter,
  onBranchFilter,
  onCustomRange,
  onReset,
  organizations,
  branches,
  entries,
  expenses,
  onEnterData,
  onEditEntry,
  onDeleteEntry,
}) {
  const visibleBranches = getVisibleBranches(currentUser, branches, filters)
  const timeSeriesData = getTimeSeriesData(currentUser, branches, entries, expenses, filters)
  const fuelBreakdown = getFuelTypeBreakdown(currentUser, branches, entries, filters)
  const hasChartData = timeSeriesData.length > 0

  return (
    <div className="animate-fadeIn space-y-4 sm:space-y-6">
      <FilterPanel
        currentUser={currentUser}
        filters={filters}
        organizations={organizations}
        branches={branches}
        onDateFilter={onDateFilter}
        onFuelTypeFilter={onFuelTypeFilter}
        onOrgFilter={onOrgFilter}
        onBranchFilter={onBranchFilter}
        onCustomRange={onCustomRange}
        onReset={onReset}
      />

      <MetricCards
        currentUser={currentUser}
        filters={filters}
        branches={branches}
        entries={entries}
        expenses={expenses}
      />

      {hasChartData && (
        <div className="space-y-3">
          <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Charts</h2>
          <RevenueChart data={timeSeriesData} />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <SalesChart data={timeSeriesData} />
            <FuelBreakdownChart data={fuelBreakdown} />
          </div>
        </div>
      )}

      {visibleBranches.length === 0 ? (
        <div className="bg-white rounded-xl shadow-lg p-12 text-center">
          <AlertCircle className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-gray-600 mb-2">No Branches Found</h3>
          <p className="text-gray-400 text-sm">No branches match the current filters.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {visibleBranches.map((branch) => {
            const org = organizations.find((o) => o.id === branch.organizationId)
            return (
              <BranchCard
                key={branch.id}
                branch={branch}
                organization={org}
                filters={filters}
                entries={entries}
                expenses={expenses}
                currentUser={currentUser}
                onEnterData={onEnterData}
                onEditEntry={onEditEntry}
                onDeleteEntry={onDeleteEntry}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
